import { Address } from '@vfde-sails/avc-core';
import { AddressForm } from '../interface';

/**
 * Returns partial Address from AddressForm
 */
export const getAddressFromForm = ({ city, street, number }: AddressForm): Partial<Address> => ({
    city: Number.isInteger(+city) ? '' : city,
    zipcode: Number.isInteger(+city) ? city : '',
    street,
    housenumber: number,
});
